import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00827711"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-rating-bar" }
const _hoisted_2 = { class: "frisbuy-rating-bar__rate-label" }
const _hoisted_3 = { class: "frisbuy-rating-bar__rate-icon" }
const _hoisted_4 = { class: "frisbuy-rating-bar__rate-progress-bar" }
const _hoisted_5 = { class: "frisbuy-rating-bar__rate-count" }

import StarRounded from "../../Icons/StarRounded.vue";
import StarSoftRounded from "../../Icons/StarSoftRounded.vue";
// Types
import { TRating } from "../../interfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'RatingBar',
  props: {
    divisionByRating: {},
    isSoftStarIcon: { type: Boolean }
  },
  setup(__props: any) {

// Icons
const props = __props;

const generalRating: number = props.divisionByRating.reduce(
  (accumulator, currentValue) => {
    return accumulator + currentValue.count;
  },
  0
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.divisionByRating, (rating) => {
      return (_openBlock(), _createElementBlock("li", {
        key: rating.label,
        class: "frisbuy-rating-bar__rate"
      }, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(rating.label), 1),
        _createElementVNode("span", _hoisted_3, [
          (!props.isSoftStarIcon)
            ? (_openBlock(), _createBlock(StarRounded, {
                key: 0,
                width: "12px"
              }))
            : (_openBlock(), _createBlock(StarSoftRounded, {
                key: 1,
                width: "12px"
              }))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "frisbuy-rate-progress-bar__progress",
            style: _normalizeStyle({ width: `${(rating.count / _unref(generalRating)) * 100}%` })
          }, null, 4)
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(rating.count), 1)
      ]))
    }), 128))
  ]))
}
}

})